// export const BASE_API_URL = "http://localhost:3001/v1/api/";
// export const BASE_API_URL = "http://54.152.167.122:3001/v1/api/";
export const BASE_API_URL = "https://admin.flyrodeo.com/v1/api/";
export const ACCESS_TOKEN = JSON.parse(localStorage.getItem("ACCESS_TOKEN"));
export const S3_BASE_URL = "https://rodeooo.s3.amazonaws.com/";
